import { render, staticRenderFns } from "./Waves.vue?vue&type=template&id=64421a16&scoped=true"
import script from "./Waves.vue?vue&type=script&lang=js"
export * from "./Waves.vue?vue&type=script&lang=js"
import style0 from "./Waves.vue?vue&type=style&index=0&id=64421a16&prod&lang=scss&scoped=true"
import style1 from "./Waves.vue?vue&type=style&index=1&id=64421a16&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64421a16",
  null
  
)

export default component.exports